// V.R. Enterprises - Data

export const CATALOGUE_URL = "https://customer-assets.emergentagent.com/job_dozz-premium-supply/artifacts/ep09rtxr_VR%20Enterprises%20Catalogue-1.pdf";
export const DOZZ_LOGO_URL = "https://customer-assets.emergentagent.com/job_dozz-premium-supply/artifacts/vbt47ttf_WhatsApp%20Image%202026-02-13%20at%2016.56.14.jpeg";
export const DOZZ_GOLD_LOGO_URL = "https://customer-assets.emergentagent.com/job_c3693396-3483-437b-be99-feb823559cec/artifacts/0dhtpkm7_WhatsApp%20Image%202026-02-13%20at%2019.07.08.jpeg";
export const VIDYUTSAFE_LOGO_URL = "https://customer-assets.emergentagent.com/job_c3693396-3483-437b-be99-feb823559cec/artifacts/iuukhl2d_unnamed.jpg";

// Product images - using images from dozzhoses.com
export const productImages = {
  "electrical-insulating-mats": "https://www.dozzhoses.com/assets/img/products/vidyutsafe-insulating-mats3.jpeg",
  "hydraulic-hoses": "https://www.dozzhoses.com/assets/img/products/dozz-rubber-hose1.png",
  "air-pneumatic-hoses": "https://www.dozzhoses.com/assets/img/home-products/p6.png",
  "rubber-water-hoses": "https://www.dozzhoses.com/assets/img/home-products/p7.png",
  "thermoplastic-hoses": "https://www.dozzhoses.com/assets/img/home-products/p12.png",
  "rock-drill-hoses": "https://www.dozzhoses.com/assets/img/home-products/p10.png",
  "chemical-hoses": "https://www.dozzhoses.com/assets/img/home-products/p4.png",
  "ss-teflon-bellow-hoses": "https://www.dozzhoses.com/assets/img/products/dozz-expansion-bellow-hose-joint-assemblies1.jpg",
  "steam-hoses": "https://www.dozzhoses.com/assets/img/home-products/p8.png",
  "carbon-free-hoses": "https://www.dozzhoses.com/assets/img/home-products/p3.png",
  "sand-blast-hoses": "https://customer-assets.emergentagent.com/job_dozz-premium-supply/artifacts/89ig0eet_WhatsApp%20Image%202026-02-13%20at%2009.35.56.jpeg",
  "lpg-hoses": "https://customer-assets.emergentagent.com/job_dozz-premium-supply/artifacts/nr7xem39_WhatsApp%20Image%202026-02-13%20at%2009.35.58.jpeg",
  "co2-fire-extinguisher-hose": "https://www.dozzhoses.com/assets/img/home-products/p1.png",
  "abc-fire-extinguisher-hose": "https://www.dozzhoses.com/assets/img/home-products/p2.png",
};

// Additional product gallery images with labels - using dozzhoses.com images
export const productGallery = {
  "electrical-insulating-mats": [
    { 
      url: "https://www.dozzhoses.com/assets/img/products/vidyutsafe-insulating-mats4.PNG",
      label: "VIDYUTSAFE Insulating Mats - Multiple Colors"
    },
    { 
      url: "https://www.dozzhoses.com/assets/img/products/vidyutsafe-insulating-mats1.PNG",
      label: "Technical Specifications - Class A, B, C"
    },
    { 
      url: "https://www.dozzhoses.com/assets/img/products/vidyutsafe-insulating-mats2.PNG",
      label: "Physical Properties & Test Standards"
    }
  ],
  "hydraulic-hoses": [
    { url: "https://www.dozzhoses.com/assets/img/products/dozz-rubber-hose2.png", label: "SAE 100 R1/R2 Hydraulic Hose Construction" },
  ],
  "air-pneumatic-hoses": [
    { url: "https://www.dozzhoses.com/assets/img/home-products/p6.png", label: "DOZZ Air/Pneumatic Hose - IS 446" },
  ],
  "steam-hoses": [
    { url: "https://www.dozzhoses.com/assets/img/home-products/p8.png", label: "DOZZ Steam Hose - High Temperature" },
  ],
  "rock-drill-hoses": [
    { url: "https://www.dozzhoses.com/assets/img/home-products/p10.png", label: "DOZZ Rock Drill Hose - Steel Wire Braid" },
  ],
  "chemical-hoses": [
    { url: "https://www.dozzhoses.com/assets/img/home-products/p4.png", label: "DOZZ Chemical Hose - EPDM Rubber" },
  ],
  "ss-teflon-bellow-hoses": [
    { url: "https://www.dozzhoses.com/assets/img/products/dozz-expansion-bellow-hose-joint-assemblies1.jpg", label: "SS Bellow Expansion Joint" },
    { url: "https://www.dozzhoses.com/assets/img/products/dozz-expansion-bellow-hose-joint-assemblies2.jpg", label: "Metallic Bellow Assembly" },
    { url: "https://www.dozzhoses.com/assets/img/products/dozz-expansion-bellow-hose-joint-assemblies3.png", label: "Flanged Connection Type" },
    { url: "https://www.dozzhoses.com/assets/img/products/dozz-trflon-hose.png", label: "PTFE Teflon Hose - SS Braided" },
    { url: "https://www.dozzhoses.com/assets/img/products/dozz-trflon-hoses1.PNG", label: "Teflon Hose Technical Specs" },
  ],
  "co2-fire-extinguisher-hose": [
    { url: "https://www.dozzhoses.com/assets/img/products/carbon-di-oxide-hose-fire-extinguisher1.PNG", label: "CO2 Fire Extinguisher Hose Assembly" },
    { url: "https://www.dozzhoses.com/assets/img/products/carbon-di-oxide-hose-fire-extinguisher2.PNG", label: "CO2 Hose with Horn" },
    { url: "https://www.dozzhoses.com/assets/img/products/carbon-di-oxide-hose-fire-extinguisher3.PNG", label: "CO2 Extinguisher Complete Set" },
  ],
  "abc-fire-extinguisher-hose": [
    { url: "https://www.dozzhoses.com/assets/img/products/dozz-abc-fire-extinguisher-hose1.PNG", label: "ABC Fire Extinguisher Hose" },
    { url: "https://www.dozzhoses.com/assets/img/products/dozz-abc-fire-extinguisher-hose2.PNG", label: "ABC Hose with Nozzle" },
    { url: "https://www.dozzhoses.com/assets/img/products/dozz-abc-fire-extinguisher-hose3.PNG", label: "ABC Extinguisher Assembly" },
  ],
};

export const companyInfo = {
  name: "V.R. Enterprises",
  tagline: "Manufacturers of Industrial Hoses & Electrical Insulating Mats",
  established: 1984,
  experience: "40+",
  iso: "ISO 9001:2015 Certified",
  address: {
    full: "F5, Site No. 1, BS Road, Industrial Area, Ghaziabad, UP 201009",
    city: "Ghaziabad",
    state: "Uttar Pradesh",
    pin: "201009"
  },
  emails: ["vrenterprises0@gmail.com", "dozzvre@gmail.com"],
  phones: ["+91 9899395689", "+91 9910673407"],
  whatsapp: "919899395689",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.0123456789!2d77.4567890123456!3d28.6789012345678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sV.R.%20Enterprises!5e0!3m2!1sen!2sin!4v1234567890",
  mapLink: "https://share.google/ejNqGUl1qyT1nD6Rs",
  vision: "To create a global presence by providing superior quality rubber and hose solutions.",
  about: "V.R. Enterprises is an ISO 9001:2015 certified manufacturer established in 1984, specializing in industrial hoses and ISI marked electrical insulating mats. With over four decades of manufacturing excellence, we supply high-performance rubber and thermoplastic hose solutions across India.",
  highlights: [
    "ISI certified products",
    "Stringent quality testing",
    "Bulk production capability",
    "Custom hose solutions",
    "Government & PSU supply experience"
  ]
};

export const certifications = [
  { name: "ISO 9001:2015", description: "Quality Management System" },
  { name: "BIS", description: "Bureau of Indian Standards" },
  { name: "ERDA", description: "Electrical Research & Development Association" },
  { name: "CPRI", description: "Central Power Research Institute" },
  { name: "NTH", description: "National Test House" }
];

export const brands = [
  {
    name: "DOZZ",
    tagline: "Complete Hose Solution",
    description: "Comprehensive range of industrial hoses engineered for reliability and performance across all applications. From water transfer to heavy-duty industrial use.",
    color: "#1E3A5F",
    bgClass: "bg-navy-800"
  },
  {
    name: "DOZZ GOLD",
    tagline: "High Pressure Hydraulic & Sand Blast Hoses",
    description: "Premium grade high-pressure hydraulic hoses built for extreme conditions. Steel wire braided construction for maximum durability.",
    color: "#92700C",
    bgClass: "bg-amber-800"
  },
  {
    name: "OSCO",
    tagline: "ISI Certified Thermoplastic Hoses",
    description: "ISI certified thermoplastic hoses conforming to IS 12585 standards. Lightweight yet robust for diverse industrial applications.",
    color: "#1B5E20",
    bgClass: "bg-green-800"
  },
  {
    name: "VIDYUTSAFE",
    tagline: "ISI Marked Electrical Insulating Mats",
    description: "Safety-certified electrical insulating mats conforming to IS 15652-2006. Trusted protection for substations and power plants.",
    color: "#C41E24",
    bgClass: "bg-ind-red-600"
  },
  {
    name: "LOCO",
    tagline: "Industrial Hose Range",
    description: "Growing range of industrial hoses designed for emerging market needs. Reliable, cost-effective solutions for expanding operations.",
    color: "#4A148C",
    bgClass: "bg-purple-900"
  }
];

export const products = [
  {
    id: 1,
    slug: "electrical-insulating-mats",
    name: "Electrical Insulating Mats",
    brand: "VIDYUTSAFE / DOZZ",
    standard: "IS: 15652-2006",
    certified: true,
    icon: "Zap",
    shortDescription: "ISI Certified electrical insulating mats for substations, power plants, and control panels. First brand in India to obtain ISI Mark on Insulating Mats.",
    classes: [
      { name: "Class A", voltage: "3.3 KV", thickness: "2.00 mm", dielectricStrength: "30 KV" },
      { name: "Class B", voltage: "11 KV", thickness: "2.50 mm", dielectricStrength: "45 KV" },
      { name: "Class C", voltage: "33 KV", thickness: "3.00 mm", dielectricStrength: "65 KV" }
    ],
    features: [
      "High dielectric strength (up to 65 KV)",
      "Flame retardant — retarded to flame",
      "Oil & chemical resistant (NaOH, Transformer Oil, HCL)",
      "Tensile strength: 15 N/mm² (Min.)",
      "Elongation at break: 250% (Min.)",
      "Insulation resistance: 10,00,000 MΩ (Min.)",
      "Leakage current: 10 mA (Max.)",
      "Low temperature resistant (-10±3°C)",
      "Made from blend of Synthetic Polymers",
      "Available in Black / Red / Blue"
    ],
    applications: [
      "Electrical Sub-Stations",
      "Transformer Rooms",
      "Power Plants",
      "Electrical Panels",
      "Switch Rooms",
      "AC Plant Rooms",
      "LT/HT Labs",
      "Generator Rooms",
      "Lift Machine Rooms",
      "Around Bus Bars"
    ],
    specs: {
      standard: "IS: 15652-2006 (Superseding IS:5424-1969)",
      material: "Blend of Synthetic Polymers",
      colour: "Black / Red / Blue",
      finish: "Both Side Patterned / One Side Plain",
      width: "Up to 1.2 Mtr.",
      length: "Long Length up to 100 Mtr.",
      tensileStrength: "15 N/mm² (Min.)",
      elongation: "250% (Min.)",
      insulationResistance: "10,00,000 MΩ (Min.)",
      leakageCurrent: "10 mA (Max.)"
    },
    sizeTable: [
      { class: "A", thickness: "2.00 mm", dielectric: "30 KV", acVoltage: "3.3 KV" },
      { class: "B", thickness: "2.50 mm", dielectric: "45 KV", acVoltage: "11 KV" },
      { class: "C", thickness: "3.00 mm", dielectric: "65 KV", acVoltage: "33 KV" }
    ],
    cta: "Get Insulating Mat Quote"
  },
  {
    id: 2,
    slug: "hydraulic-hoses",
    name: "Hydraulic Hoses",
    brand: "DOZZ GOLD",
    standard: "SAE 100 R1/R2/R3/R6",
    certified: true,
    icon: "Gauge",
    shortDescription: "High pressure SAE 100 series hydraulic hoses with single/double steel wire braid reinforcement for heavy-duty industrial and construction equipment.",
    types: [
      { name: "SAE 100 R1 (1SN)", pressure: "225-3260 PSI", reinforcement: "Single Steel Wire Braid" },
      { name: "SAE 100 R2 (2SN)", pressure: "400-5800 PSI", reinforcement: "Double Steel Wire Braid" },
      { name: "SAE 100 R3 (2TE)", pressure: "565-1500 PSI", reinforcement: "Nylon Braid" },
      { name: "SAE 100 R6 (2TE)", pressure: "300-400 PSI", reinforcement: "Nylon Braid" }
    ],
    features: [
      "Single & double steel wire braid reinforcement",
      "Working pressure up to 5800 PSI (400 BAR)",
      "Burst pressure up to 23200 PSI (1600 BAR)",
      "Oil resistant synthetic rubber inner tube",
      "Weather & abrasion resistant cover",
      "Sizes from 1/4\" (6.4mm) to 2\" (50.8mm)",
      "Temperature range: -40°C to +100°C"
    ],
    applications: [
      "Excavators & earthmovers",
      "Hydraulic machinery",
      "Construction equipment",
      "Industrial automation",
      "Mobile hydraulic systems",
      "Agricultural machinery"
    ],
    specs: {
      workingPressure: "Up to 5800 PSI (400 BAR)",
      burstPressure: "Up to 23200 PSI (1600 BAR)",
      temperature: "-40°C to +100°C",
      reinforcement: "Steel Wire Braid (Single/Double)",
      innerTube: "Oil resistant synthetic rubber",
      cover: "Weather & abrasion resistant rubber",
      sizes: "1/4\" to 2\" (6.4mm to 50.8mm)"
    },
    sizeTable: [
      { size: '1/4" (6.4mm)', r1WP: "3260 PSI", r1BP: "13040 PSI", r2WP: "5800 PSI", r2BP: "23200 PSI" },
      { size: '3/8" (9.5mm)', r1WP: "2610 PSI", r1BP: "10440 PSI", r2WP: "4640 PSI", r2BP: "18560 PSI" },
      { size: '1/2" (12.7mm)', r1WP: "2175 PSI", r1BP: "8700 PSI", r2WP: "4060 PSI", r2BP: "16240 PSI" },
      { size: '3/4" (19mm)', r1WP: "1450 PSI", r1BP: "5800 PSI", r2WP: "2900 PSI", r2BP: "11600 PSI" },
      { size: '1" (25.4mm)', r1WP: "1160 PSI", r1BP: "4640 PSI", r2WP: "2320 PSI", r2BP: "9280 PSI" },
      { size: '1-1/2" (38.1mm)', r1WP: "725 PSI", r1BP: "2900 PSI", r2WP: "1450 PSI", r2BP: "5800 PSI" },
      { size: '2" (50.8mm)', r1WP: "580 PSI", r1BP: "2320 PSI", r2WP: "1150 PSI", r2BP: "4600 PSI" }
    ],
    cta: "Request Hydraulic Hose Pricing"
  },
  {
    id: 3,
    slug: "air-pneumatic-hoses",
    name: "Air / Pneumatic Hoses",
    brand: "DOZZ",
    standard: "IS 446 Type 2 & Type 3",
    certified: true,
    icon: "Wind",
    shortDescription: "Conforming to IS 446 Type 2 & Type 3 standards. Designed for compressor lines, industrial workshops, and pneumatic systems.",
    types: [
      { name: "IS 446 Type 2", pressure: "230 PSI (16 BAR)", burstPressure: "930 PSI (64 BAR)" },
      { name: "IS 446 Type 3", pressure: "360 PSI (25 BAR)", burstPressure: "1440 PSI (100 BAR)" }
    ],
    features: [
      "Conforming to IS: 446 Type 2 & Type 3",
      "Type 2: Working pressure 230 PSI (16 BAR)",
      "Type 3: Working pressure 360 PSI (25 BAR)",
      "High flexibility & kink resistant",
      "Oil mist resistant",
      "Weather resistant cover",
      "Sizes from 1/4\" (6.3mm) to 2\" (51mm)"
    ],
    applications: [
      "Compressor lines",
      "Industrial workshops",
      "Pneumatic systems",
      "Air tools & equipment",
      "Construction sites",
      "Manufacturing plants"
    ],
    specs: {
      standard: "IS: 446 Type 2 & Type 3",
      type2WorkingPressure: "230 PSI (16 BAR)",
      type2BurstPressure: "930 PSI (64 BAR)",
      type3WorkingPressure: "360 PSI (25 BAR)",
      type3BurstPressure: "1440 PSI (100 BAR)",
      sizes: "1/4\" to 2\" (6.3mm to 51mm)"
    },
    sizeTable: [
      { size: '1/4" (6.3mm)', type2WP: "230 PSI", type2BP: "930 PSI", type3WP: "360 PSI", type3BP: "1440 PSI" },
      { size: '3/8" (10mm)', type2WP: "230 PSI", type2BP: "930 PSI", type3WP: "360 PSI", type3BP: "1440 PSI" },
      { size: '1/2" (12.5mm)', type2WP: "230 PSI", type2BP: "930 PSI", type3WP: "360 PSI", type3BP: "1440 PSI" },
      { size: '3/4" (20mm)', type2WP: "230 PSI", type2BP: "930 PSI", type3WP: "360 PSI", type3BP: "1440 PSI" },
      { size: '1" (25mm)', type2WP: "230 PSI", type2BP: "930 PSI", type3WP: "360 PSI", type3BP: "1440 PSI" },
      { size: '2" (51mm)', type2WP: "230 PSI", type2BP: "930 PSI", type3WP: "360 PSI", type3BP: "1440 PSI" }
    ],
    cta: "Get Pneumatic Hose Quote"
  },
  {
    id: 4,
    slug: "rubber-water-hoses",
    name: "Rubber Water Hoses",
    brand: "DOZZ",
    standard: "IS 444 Type 1/2/3",
    certified: true,
    icon: "Droplets",
    shortDescription: "ISI 444 certified rubber water hoses available in Type 1, 2, and 3 configurations for various pressure requirements.",
    types: [
      { name: "Type 1", pressure: "87 PSI (6 BAR)", burstPressure: "260 PSI (18 BAR)", use: "General purpose water delivery" },
      { name: "Type 2", pressure: "145 PSI (10 BAR)", burstPressure: "435 PSI (30 BAR)", use: "Medium pressure water transfer" },
      { name: "Type 3", pressure: "360 PSI (25 BAR)", burstPressure: "1440 PSI (100 BAR)", use: "High pressure water applications" }
    ],
    features: [
      "ISI 444 certified (Type 1, 2 & 3)",
      "Type 1: WP 87 PSI / BP 260 PSI",
      "Type 2: WP 145 PSI / BP 435 PSI",
      "Type 3: WP 360 PSI / BP 1440 PSI",
      "UV resistant outer cover",
      "Reinforced construction",
      "Sizes from 3/8\" (10mm) to 2\" (50mm)"
    ],
    applications: [
      "Municipal water supply",
      "Construction sites",
      "Agricultural irrigation",
      "Industrial water transfer",
      "Fire fighting (Type 3)",
      "General purpose water delivery"
    ],
    specs: {
      standard: "IS: 444 Type 1, 2 & 3",
      type1WorkingPressure: "87 PSI (6 BAR)",
      type1BurstPressure: "260 PSI (18 BAR)",
      type2WorkingPressure: "145 PSI (10 BAR)",
      type2BurstPressure: "435 PSI (30 BAR)",
      type3WorkingPressure: "360 PSI (25 BAR)",
      type3BurstPressure: "1440 PSI (100 BAR)",
      sizes: "3/8\" to 2\" (10mm to 50mm)"
    },
    cta: "Get Water Hose Quote"
  },
  {
    id: 5,
    slug: "steam-hoses",
    name: "Steam Hoses",
    brand: "DOZZ",
    standard: "Industrial Grade",
    certified: true,
    icon: "Flame",
    shortDescription: "Single & double steel wire braid steam hoses for high temperature steam transfer in process industries and power plants.",
    types: [
      { name: "Single Wire Braid", pressure: "205 PSI (14 BAR)", burstPressure: "2052 PSI (140 BAR)", sizes: "1/2\" to 1\"" },
      { name: "Double Wire Braid", pressure: "254 PSI (17.5 BAR)", burstPressure: "2537 PSI (175 BAR)", sizes: "1/2\" to 2\"" }
    ],
    features: [
      "Heat resistant inner tube for saturated steam",
      "Single wire braid: WP 205 PSI (14 BAR)",
      "Double wire braid: WP 254 PSI (17.5 BAR)",
      "Burst pressure up to 2537 PSI (175 BAR)",
      "High temperature resistance up to +210°C",
      "Steel wire braid reinforcement",
      "Sizes from 1/2\" (12.5mm) to 2\" (51mm)"
    ],
    applications: [
      "Process industries",
      "Power plants",
      "Refineries",
      "Chemical plants",
      "Steam cleaning",
      "Saturated steam transfer"
    ],
    specs: {
      singleBraidWP: "205 PSI (14 BAR)",
      singleBraidBP: "2052 PSI (140 BAR)",
      doubleBraidWP: "254 PSI (17.5 BAR)",
      doubleBraidBP: "2537 PSI (175 BAR)",
      temperature: "Up to +210°C",
      construction: "Steel wire braid reinforcement",
      sizes: "1/2\" to 2\" (12.5mm to 51mm)"
    },
    cta: "Get Steam Hose Quote"
  },
  {
    id: 6,
    slug: "thermoplastic-hoses",
    name: "Thermoplastic Hoses",
    brand: "OSCO",
    standard: "IS 12585 Type 1 & 2",
    certified: true,
    icon: "Layers",
    shortDescription: "ISI 12585 certified thermoplastic hoses with seamless bore. Widely used in fire fighting hose reels, industries, agriculture, mines, and dams.",
    types: [
      { name: "Type 1", pressure: "87 PSI (6 BAR)", burstPressure: "260 PSI (18 BAR)", use: "General purpose / Low pressure" },
      { name: "Type 2", pressure: "145 PSI (10 BAR)", burstPressure: "435 PSI (30 BAR)", use: "Medium pressure / Fire hose reels" }
    ],
    features: [
      "ISI 12585 certified (Type 1 & 2)",
      "Seamless and smooth bore inner lining",
      "High strength synthetic/natural yarn reinforcement",
      "Weather & abrasion resistant thermoplastic cover",
      "Type 1: WP 87 PSI / BP 260 PSI",
      "Type 2: WP 145 PSI / BP 435 PSI",
      "Bore size: 20mm, Lining thickness: 1.50mm (min.)",
      "Adhesion: 1.4 KN/m (Min.)"
    ],
    applications: [
      "Fire fighting hose reels",
      "Industrial applications",
      "Home & agriculture projects",
      "Mines and dams",
      "Pressure washing",
      "Hydraulic systems"
    ],
    specs: {
      standard: "IS: 12585 Type 1 & 2",
      bore: "20mm",
      liningThickness: "1.50 mm (Min.)",
      coverThickness: "1.00 mm (Min.)",
      type1WorkingPressure: "87 PSI (0.60 MPa)",
      type1BurstPressure: "260 PSI (1.90 MPa)",
      type2WorkingPressure: "145 PSI (1.00 MPa)",
      type2BurstPressure: "435 PSI (3.15 MPa)",
      reinforcement: "High strength synthetic/natural yarn",
      adhesion: "1.4 KN/m (Min.)"
    },
    cta: "Get Thermoplastic Hose Quote"
  },
  {
    id: 7,
    slug: "rock-drill-hoses",
    name: "Rock Drill Hoses",
    brand: "DOZZ",
    standard: "As per IS: 446",
    certified: true,
    icon: "Sparkles",
    shortDescription: "Heavy-duty single steel wire braid rock drill hoses for mining, quarries, and construction drilling operations.",
    features: [
      "Single steel wire braid reinforcement",
      "Working pressure up to 750 PSI (50 BAR)",
      "Burst pressure up to 3000 PSI (200 BAR)",
      "Extra tough abrasion resistant cover",
      "Oil mist resistant inner tube",
      "Flexible in cold conditions",
      "Sizes from 3/8\" (10mm) to 2\" (50mm)",
      "As per IS: 446 standards"
    ],
    applications: [
      "Mining operations",
      "Quarries",
      "Tunnel boring",
      "Construction drilling",
      "Rock breaking equipment",
      "Pneumatic drills"
    ],
    specs: {
      standard: "As per IS: 446",
      workingPressure: "Up to 750 PSI (50 BAR)",
      burstPressure: "Up to 3000 PSI (200 BAR)",
      reinforcement: "Single Steel Wire Braid",
      temperature: "-40°C to +80°C",
      sizes: "3/8\" to 2\" (10mm to 50mm)"
    },
    sizeTable: [
      { size: '3/8" (10mm)', wp: "750 PSI", bp: "3000 PSI" },
      { size: '1/2" (12.5mm)', wp: "750 PSI", bp: "3000 PSI" },
      { size: '3/4" (20mm)', wp: "750 PSI", bp: "3000 PSI" },
      { size: '1" (25mm)', wp: "750 PSI", bp: "3000 PSI" },
      { size: '1-1/2" (38mm)', wp: "750 PSI", bp: "3000 PSI" },
      { size: '2" (50mm)', wp: "600 PSI", bp: "2400 PSI" }
    ],
    cta: "Get Rock Drill Hose Quote"
  },
  {
    id: 8,
    slug: "sand-blast-hoses",
    name: "Sand Blast Hoses",
    brand: "DOZZ GOLD",
    standard: "Industrial Grade",
    certified: false,
    icon: "Sparkles",
    shortDescription: "Premium sand blasting hoses with ultra-high abrasion resistance for surface preparation, shipyard operations, and steel fabrication.",
    features: [
      "Ultra-high abrasion resistance",
      "Working pressure: 220 PSI (15 BAR)",
      "Burst pressure: 660 PSI (45 BAR)",
      "Natural rubber lining for sand transfer",
      "Static dissipating construction",
      "Heavy-duty reinforcement",
      "Sizes from 3/4\" (20mm) to 2\" (50mm)"
    ],
    applications: [
      "Abrasive blasting",
      "Surface preparation",
      "Shipyard operations",
      "Steel fabrication",
      "Paint removal",
      "Industrial cleaning"
    ],
    specs: {
      workingPressure: "220 PSI (15 BAR)",
      burstPressure: "660 PSI (45 BAR)",
      innerTube: "Natural rubber, abrasion resistant",
      reinforcement: "Heavy-duty textile braid",
      sizes: "3/4\" to 2\" (20mm to 50mm)"
    },
    sizeTable: [
      { size: '3/4" (20mm)', wp: "220 PSI", bp: "660 PSI" },
      { size: '1" (25mm)', wp: "220 PSI", bp: "660 PSI" },
      { size: '1-1/4" (31.5mm)', wp: "220 PSI", bp: "660 PSI" },
      { size: '1-1/2" (38mm)', wp: "220 PSI", bp: "660 PSI" },
      { size: '2" (50mm)', wp: "220 PSI", bp: "660 PSI" }
    ],
    cta: "Get Sand Blast Hose Quote"
  },
  {
    id: 9,
    slug: "chemical-hoses",
    name: "Chemical Hoses",
    brand: "DOZZ",
    standard: "Industrial Grade",
    certified: false,
    icon: "FlaskConical",
    shortDescription: "Chemical resistant hoses for safe transfer of acids, alkalis, solvents, and corrosive fluids in chemical and petrochemical facilities.",
    features: [
      "Wide chemical compatibility",
      "Working pressure: 150 PSI (10 BAR)",
      "Burst pressure: 600 PSI (40 BAR)",
      "UHMWPE / chemical resistant inner tube",
      "Anti-static construction",
      "Corrugated cover for flexibility",
      "Sizes from 1/2\" (12.5mm) to 2\" (50mm)"
    ],
    applications: [
      "Chemical plants",
      "Pharmaceutical industry",
      "Petrochemical facilities",
      "Tank truck loading/unloading",
      "Acid & alkali transfer",
      "Solvent handling"
    ],
    specs: {
      workingPressure: "150 PSI (10 BAR)",
      burstPressure: "600 PSI (40 BAR)",
      innerTube: "UHMWPE / Chemical resistant",
      temperature: "-30°C to +100°C",
      sizes: "1/2\" to 2\" (12.5mm to 50mm)"
    },
    sizeTable: [
      { size: '1/2" (12.5mm)', wp: "150 PSI", bp: "600 PSI" },
      { size: '3/4" (20mm)', wp: "150 PSI", bp: "600 PSI" },
      { size: '1" (25mm)', wp: "150 PSI", bp: "600 PSI" },
      { size: '1-1/4" (31.5mm)', wp: "150 PSI", bp: "600 PSI" },
      { size: '1-1/2" (38mm)', wp: "150 PSI", bp: "600 PSI" },
      { size: '2" (50mm)', wp: "150 PSI", bp: "600 PSI" }
    ],
    cta: "Get Chemical Hose Quote"
  },
  {
    id: 10,
    slug: "carbon-free-hoses",
    name: "Carbon Free Hoses",
    brand: "DOZZ",
    standard: "Industrial Grade",
    certified: false,
    icon: "Leaf",
    shortDescription: "Zero carbon contamination hoses for paint manufacturing, food processing, pharmaceutical, and beverage industries.",
    features: [
      "Zero carbon contamination guaranteed",
      "Working pressure: 235 PSI (16 BAR)",
      "Burst pressure: 940 PSI (64 BAR)",
      "High purity inner tube",
      "Clean room compatible",
      "Chemical resistant construction",
      "Sizes from 1/2\" (12.5mm) to 2\" (50mm)"
    ],
    applications: [
      "Paint manufacturing",
      "Food processing",
      "Pharmaceutical industry",
      "Beverage industry",
      "Clean room applications",
      "High purity fluid transfer"
    ],
    specs: {
      workingPressure: "235 PSI (16 BAR)",
      burstPressure: "940 PSI (64 BAR)",
      innerTube: "Carbon-free, high purity rubber",
      temperature: "-20°C to +80°C",
      sizes: "1/2\" to 2\" (12.5mm to 50mm)"
    },
    sizeTable: [
      { size: '1/2" (12.5mm)', wp: "235 PSI", bp: "940 PSI" },
      { size: '3/4" (20mm)', wp: "235 PSI", bp: "940 PSI" },
      { size: '1" (25mm)', wp: "235 PSI", bp: "940 PSI" },
      { size: '1-1/4" (31.5mm)', wp: "235 PSI", bp: "940 PSI" },
      { size: '1-1/2" (38mm)', wp: "235 PSI", bp: "940 PSI" },
      { size: '2" (50mm)', wp: "235 PSI", bp: "940 PSI" }
    ],
    cta: "Get Carbon Free Hose Quote"
  },
  {
    id: 11,
    slug: "lpg-hoses",
    name: "LPG Hoses",
    brand: "DOZZ",
    standard: "IS 9573",
    certified: true,
    icon: "Fuel",
    shortDescription: "Certified LPG hoses for safe gas transfer in domestic and industrial applications with flame retardant and gas-tight construction.",
    features: [
      "Gas tight construction",
      "Flame retardant material",
      "Oil resistant inner tube",
      "Reinforced for high safety",
      "UV resistant cover",
      "Conforming to IS 9573 standards"
    ],
    applications: [
      "LPG bottling plants",
      "Gas distribution systems",
      "Industrial gas lines",
      "Automotive LPG systems",
      "Commercial kitchens",
      "Gas tanker loading"
    ],
    specs: {
      standard: "IS 9573",
      workingPressure: "Up to 300 PSI",
      burstPressure: "Up to 1200 PSI",
      temperature: "-30°C to +70°C",
      construction: "Multi-layer reinforced",
      sizes: "Various sizes available"
    },
    cta: "Get LPG Hose Quote"
  },
  {
    id: 12,
    slug: "ss-teflon-bellow-hoses",
    name: "SS Teflon & Bellow Hoses",
    brand: "DOZZ",
    standard: "Industrial Grade",
    certified: false,
    icon: "Link",
    shortDescription: "Stainless steel PTFE lined and metallic bellow hoses with flanged connections for extreme temperature, pressure, and corrosive applications.",
    features: [
      "PTFE (Teflon) lined bore for chemical resistance",
      "SS304 / SS316 braided exterior",
      "Corrugated metallic bellow construction",
      "Extreme temperature resistance: -200°C to +260°C",
      "High pressure capability up to 3000 PSI",
      "Corrosion proof — ideal for aggressive media",
      "Flanged, threaded, or camlock connections",
      "Vibration absorption & misalignment compensation"
    ],
    applications: [
      "High temperature steam lines",
      "Corrosive chemical transfer",
      "Cryogenic applications",
      "Food & pharmaceutical (FDA compliant)",
      "Petrochemical refineries",
      "Vibration isolation in piping"
    ],
    specs: {
      workingPressure: "Up to 3000 PSI",
      temperature: "-200°C to +260°C",
      innerTube: "PTFE (Teflon) lined / Corrugated SS Bellow",
      outerBraid: "SS304 / SS316 wire braid",
      connections: "Flanged / Threaded / Camlock",
      sizes: "1/4\" to 6\""
    },
    cta: "Get SS Teflon Hose Quote"
  },
  {
    id: 13,
    slug: "co2-fire-extinguisher-hose",
    name: "CO2 Fire Extinguisher Hose",
    brand: "DOZZ",
    standard: "BIS 16018",
    certified: true,
    icon: "Flame",
    shortDescription: "Carbon dioxide fire extinguisher hose suitable for Class B & C fires involving flammable liquids, gases, and electrical equipment.",
    features: [
      "BIS 16018 specification compliant",
      "Suitable for Class B & C fires",
      "Safe for electrical & delicate machinery",
      "Available in 1 Mtr, 2 Mtr, 3 Mtr, 5 Mtr lengths",
      "High test pressure (236 Kgf/Cm2)",
      "Quick discharge capability",
      "Durable construction for repeated use"
    ],
    applications: [
      "Flammable liquid fires",
      "Electrical equipment fires",
      "Gas fires",
      "Delicate machinery protection",
      "Server rooms",
      "Laboratories",
      "Industrial settings"
    ],
    specs: {
      standard: "BIS 16018",
      testPressure: "236 Kgf/Cm2",
      jetLength: "2.5 - 3 meters",
      availableSizes: "6.5 Kg, 9 Kg, 22.5 Kg",
      lengths: "1 Mtr, 2 Mtr, 3 Mtr, 5 Mtr"
    },
    sizeTable: [
      { description: "CO2 - 6.5 Kg", bisSpec: "16018", dischargeTime: "25 - 30 Sec", jetLength: "2.5 - 3 m", testPressure: "236 Kgf/Cm2" },
      { description: "CO2 - 9 Kg", bisSpec: "16018", dischargeTime: "30 - 35 Sec", jetLength: "2.5 - 3 m", testPressure: "236 Kgf/Cm2" },
      { description: "CO2 - 22.5 Kg", bisSpec: "16018", dischargeTime: "50 - 60 Sec", jetLength: "2.5 - 3 m", testPressure: "236 Kgf/Cm2" }
    ],
    cta: "Get CO2 Hose Quote"
  },
  {
    id: 14,
    slug: "abc-fire-extinguisher-hose",
    name: "ABC Fire Extinguisher Hose",
    brand: "DOZZ",
    standard: "BIS 15683",
    certified: true,
    icon: "Flame",
    shortDescription: "Multi-purpose ABC type fire extinguisher hose suitable for Class A, B, C & D fires involving wood, paper, flammable liquids, gases, and electrical fires.",
    features: [
      "BIS 15683 specification compliant",
      "Suitable for Class A, B, C & D fires",
      "Multi-purpose fire fighting",
      "Works on wood, paper, cloth, flammable liquids",
      "Safe for electrical fires",
      "Test pressure 35 Kgf/Cm2",
      "Various capacities available"
    ],
    applications: [
      "Combustible material fires (wood, paper, cloth)",
      "Flammable gas & liquid fires",
      "Petrol & paint fires",
      "Solvent fires",
      "Electrical fires",
      "All classes of fire"
    ],
    specs: {
      standard: "BIS 15683",
      testPressure: "35 Kgf/Cm2",
      jetLength: "2 - 7 meters",
      availableSizes: "1 Kg to 9 Kg",
      fireClasses: "A, B, C & D"
    },
    sizeTable: [
      { description: "ABC - 1 Kg", bisSpec: "15683", dischargeTime: "6 - 8 Sec", jetLength: "2 - 3 m", testPressure: "35 Kgf/Cm2" },
      { description: "ABC - 2 Kg", bisSpec: "15683", dischargeTime: "6 - 8 Sec", jetLength: "2 - 3 m", testPressure: "35 Kgf/Cm2" },
      { description: "ABC - 4 Kg", bisSpec: "15683", dischargeTime: "6 - 8 Sec", jetLength: "6 - 7 m", testPressure: "35 Kgf/Cm2" },
      { description: "ABC - 6 Kg", bisSpec: "15683", dischargeTime: "10 - 12 Sec", jetLength: "6 - 7 m", testPressure: "35 Kgf/Cm2" },
      { description: "ABC - 9 Kg", bisSpec: "15683", dischargeTime: "12 - 18 Sec", jetLength: "6 - 7 m", testPressure: "35 Kgf/Cm2" }
    ],
    cta: "Get ABC Fire Hose Quote"
  }
];

export const clients = [
  "BHEL", "GAIL", "SAIL", "ONGC", "Reliance",
  "Indian Oil", "HP", "BSES", "Vizag Steel",
  "Aditya Birla", "UltraTech", "NALCO",
  "Delhi Metro", "NTPC", "Power Grid", "Tata Steel"
];

export const whyChooseUs = [
  {
    title: "40+ Years Experience",
    description: "Four decades of manufacturing excellence since 1984",
    icon: "Clock"
  },
  {
    title: "ISI Certified Manufacturing",
    description: "Products certified by Bureau of Indian Standards",
    icon: "ShieldCheck"
  },
  {
    title: "Strict Quality Control",
    description: "Every batch tested as per Indian Standards before dispatch",
    icon: "ClipboardCheck"
  },
  {
    title: "Bulk Supply Capability",
    description: "Large-scale production for government & industrial orders",
    icon: "Warehouse"
  },
  {
    title: "Custom Hose Solutions",
    description: "Tailored manufacturing to meet specific requirements",
    icon: "Settings"
  },
  {
    title: "Trusted Across India | Exporting Worldwide",
    description: "Timely delivery across all states in India and international exports",
    icon: "Truck"
  },
  {
    title: "Government Tender Experience",
    description: "Proven track record with PSU & government contracts",
    icon: "Building"
  },
  {
    title: "Competitive Pricing",
    description: "Factory-direct pricing without compromising quality",
    icon: "BadgeIndianRupee"
  }
];

export const faqs = [
  {
    question: "What is ISI certified hose?",
    answer: "An ISI certified hose is a product that has been tested and certified by the Bureau of Indian Standards (BIS) to meet specific Indian Standards for quality, safety, and performance. Our hoses carry the ISI mark which ensures they meet rigorous testing requirements."
  },
  {
    question: "Which insulating mat class is suitable for 11KV?",
    answer: "Class B electrical insulating mats are suitable for 11KV applications. These mats conform to IS: 15652-2006 and are tested at ERDA and CPRI for dielectric strength. We recommend Class B mats for all 11KV substations and panel rooms."
  },
  {
    question: "Do you supply to government tenders?",
    answer: "Yes, V.R. Enterprises has extensive experience supplying to government departments and PSUs. We are registered with NSIC and have supplied to organizations like BHEL, GAIL, SAIL, ONGC, and many others through government tenders."
  },
  {
    question: "Can you provide bulk supply?",
    answer: "Absolutely. We have large-scale production capabilities at our Ghaziabad factory. We regularly fulfill bulk orders for power plants, steel plants, infrastructure projects, and government departments across India."
  },
  {
    question: "What standards do your hydraulic hoses follow?",
    answer: "Our hydraulic hoses conform to SAE 100 R1, R2, R3, and R6 standards. They are manufactured under our DOZZ GOLD brand with steel wire braid reinforcement for maximum pressure handling."
  },
  {
    question: "Do you offer custom hose solutions?",
    answer: "Yes, we provide custom hose solutions tailored to specific industrial requirements. Whether you need specific dimensions, pressure ratings, or material compositions, our engineering team can develop solutions to match your needs."
  }
];

export const heroStats = [
  { value: "40+", label: "Years Experience" },
  { value: "5000+", label: "Products Delivered" },
  { value: "500+", label: "Clients Served" },
  { value: "16+", label: "States Covered" }
];
